<template>
  <div class="ob-card">
    <v-divider class="mt-1"></v-divider>
    <div class="caption px-2 pt-3 font-weight-bold">
      {{ betsGroup.matchName }}
    </div>
    <div
      v-for="(betData, i2) in betsGroup.markets"
      :key="'betData' + i2"
      class="betdetails"
    >
      <div v-if="$breakpoint.smAndDown">
        <div class="caption px-2 pt-1">{{ betData.name }}</div>
        <div v-for="(runner, r) in betData.runners" :key="'runners' + i2 + r">
          <v-card
            v-for="(bet, j) in sortBetData(runner.bets, sortBets)"
            :key="'bet' + j"
            light
            :class="{
              secondary: bet.type == 'BACK',
              accent: bet.type == 'LAY',
              opacityLess: bet.status == 'VOID_VAR'
            }"
            class="pa-2 mybet-card caption"
            :to="
              bet.parentCategory
                ? `/sportsbook/${bet.eventType}/${bet.parentCategory.parentCategory}/${bet.parentCategory._id}`
                : ''
            "
          >
            <!-- <v-overlay
            v-if="bet.status === 'RT_INVALID_BET'"
            absolute
            opacity="0.75"
          >
            <v-tooltip top>
              <template #activator="{ on, attrs }">
                <v-btn
                  class="multiline-btn caption"
                  small
                  color="red"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark left> mdi-cancel </v-icon>
                  Invalid Bet
                </v-btn>
              </template>
              <span> {{ bet.reason }} </span>
            </v-tooltip>
          </v-overlay> -->
            <div class="font-weight-bold">
              <span v-if="bet.betType === 'fancy'">{{
                bet.type == 'BACK' ? 'YES' : 'NO'
              }}</span>

              <span v-if="bet.betType !== 'fancy'"> {{ bet.type }}</span>
              {{ bet.horse }} for {{ bet.stake | currencyFormat }} @
              <span
                v-if="bet.betType !== 'fancy' && bet.betType !== 'lineLadder'"
              >
                {{
                  (bet.betType !== 'matchOdds' && bet.placeBetCalcType === 1
                    ? (bet.averagePriceMatched - 1) * 100
                    : bet.betType !== 'matchOdds' && bet.placeBetCalcType === 2
                    ? bet.averagePriceMatched - 1
                    : bet.averagePriceMatched) | currencyFormat(3)
                }}
              </span>
              <span v-if="bet.betType === 'lineLadder'">
                {{
                  (bet.betType !== 'matchOdds' && bet.placeBetCalcType === 1
                    ? (bet.averagePriceMatched - 1) * 100
                    : bet.betType !== 'matchOdds' && bet.placeBetCalcType === 2
                    ? bet.averagePriceMatched - 1
                    : bet.averagePriceMatched) | ceil
                }}
              </span>
              <span v-if="bet.betType === 'fancy'">
                {{ ((bet.averagePriceMatched - 1) * 100) | currencyFormat }}
              </span>
              {{ bet.type == 'BACK' ? 'to win' : 'liability' }}
              <span
                v-if="
                  bet.betType !== 'bookMaker' && bet.betType !== 'lineLadder'
                "
              >
                {{
                  ((bet.averagePriceMatched - 1) * bet.stake) | currencyFormat
                }}
              </span>
              <span v-if="bet.betType === 'bookMaker'">
                {{
                  ((bet.averagePriceMatched - 1) * bet.stake)
                    | currencyFormat(2)
                }}
              </span>
              <span v-if="bet.betType === 'lineLadder'">
                {{ ((bet.betRate - 1) * bet.stake) | currencyFormat(2) }} </span
              >.
            </div>
            <div>
              <span>{{ bet.marketName }}</span>
            </div>

            <div>
              <span>Placed: </span>
              {{ $moment(bet.placedDate).format('DD/MM/YYYY, h:mm:ss a') }}
            </div>
            <div v-if="bet.status === 'VOID_VAR'" class="red--text caption">
              Void by VAR
            </div>
            <div v-if="bet.status === 'RT_INVALID_BET'" class="red--text">
              <v-tooltip top>
                <template #activator="{ on, attrs }">
                  <v-btn
                    class="multiline-btn caption pa-0"
                    small
                    color="red"
                    text
                    v-bind="attrs"
                    v-on="on"
                  >
                    Status: Invalid Bet
                  </v-btn>
                </template>
                <span> {{ bet.reason }} </span>
              </v-tooltip>
              <div class="caption">Reason: {{ bet.reason }}</div>
            </div>
          </v-card>
        </div>
      </div>
      <div v-if="$breakpoint.mdAndUp" class="oddsloop">
        <!-- <v-divider class="mt-1"></v-divider> -->
        <div
          v-for="(runner, r) in betData.runners"
          :key="'runners' + i2 + r"
          class="odds-table"
        >
          <v-simple-table tile dense>
            <template #default>
              <thead>
                <tr>
                  <th
                    class="text-left caption font-weight-bold"
                    style="width: calc(100vw - 250px)"
                  >
                    {{ betData.name }}
                  </th>
                  <th class="text-left caption">
                    {{ betData.runners.bets }}
                    <span
                      v-if="
                        betData.name === 'Match Odds' ||
                        betData.name === 'fancy' ||
                        (runner &&
                          runner.bets &&
                          runner.bets[0] &&
                          runner.bets[0].betType &&
                          runner.bets[0].betType === 'fancy')
                      "
                      >Odds</span
                    >
                    <span v-else>Runs</span>
                    <!-- Odds -->
                    <!-- {{ text }} -->
                    <!-- <span v-for="(bet, j) in runner.bets" :key="j"
                      >{{ bet.betType }}
                    </span> -->
                  </th>
                  <th class="text-left caption">Stake</th>
                  <th class="text-left caption">Profit/Liability</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(bet, j) in sortBetData(runner.bets, sortBets)"
                  :key="'bet' + j"
                  :class="{
                    secondary: bet.type == 'BACK',
                    accent: bet.type == 'LAY',
                    opacityLess: bet.status == 'VOID_VAR',
                    opacityLess: bet.status == 'RT_INVALID_BET'
                  }"
                  :to="
                    bet.parentCategory
                      ? `/sportsbook/${bet.eventType}/${bet.parentCategory.parentCategory}/${bet.parentCategory._id}`
                      : ''
                  "
                >
                  <!-- <div class="caption font-weight-bold mx-4 pt-1">
                  <div v-if="bet.status === 'VOID_VAR'" class="red--text title">
                    Void by VAR
                  </div>
                </div> -->

                  <td class="caption font-weight-bold">
                    {{ bet.horse }}
                  </td>
                  <td class="caption font-weight-bold">
                    <span
                      v-if="
                        bet.betType !== 'fancy' && bet.betType !== 'lineLadder'
                      "
                    >
                      {{
                        (bet.betType !== 'matchOdds' &&
                        bet.placeBetCalcType === 1
                          ? (bet.averagePriceMatched - 1) * 100
                          : bet.betType !== 'matchOdds' &&
                            bet.placeBetCalcType === 2
                          ? bet.averagePriceMatched - 1
                          : bet.averagePriceMatched) | currencyFormat(3)
                      }}
                    </span>
                    <span v-if="bet.betType === 'lineLadder'">
                      {{
                        (bet.betType !== 'matchOdds' &&
                        bet.placeBetCalcType === 1
                          ? (bet.averagePriceMatched - 1) * 100
                          : bet.betType !== 'matchOdds' &&
                            bet.placeBetCalcType === 2
                          ? bet.averagePriceMatched - 1
                          : bet.averagePriceMatched) | ceil
                      }}
                    </span>
                    <span
                      v-if="
                        bet.eventType &&
                        (bet.eventType === 'Horse Racing' ||
                          bet.eventType === 'Greyhound Racing') &&
                        bet.betType === 'fancy'
                      "
                    >
                      {{
                        (bet.betType !== 'matchOdds' &&
                        bet.placeBetCalcType === 1
                          ? (bet.averagePriceMatched - 1) * 100
                          : bet.betType !== 'matchOdds' &&
                            bet.placeBetCalcType === 2
                          ? bet.averagePriceMatched - 1
                          : bet.averagePriceMatched) | currencyFormat(3)
                      }}
                    </span>
                    <span v-if="bet.betType === 'fancy'">
                      {{
                        ((bet.averagePriceMatched - 1) * 100) | currencyFormat
                      }}
                    </span>
                    <div
                      v-if="
                        bet.status === 'VOID_VAR' ||
                        bet.status === 'RT_INVALID_BET'
                      "
                      class="opacity-0"
                    >
                      Status
                    </div>
                  </td>
                  <td class="caption font-weight-bold">
                    {{ bet.stake | currencyFormat }}
                    <div
                      v-if="
                        bet.status === 'VOID_VAR' ||
                        bet.status === 'RT_INVALID_BET'
                      "
                    >
                      Status
                    </div>
                  </td>
                  <td class="caption font-weight-bold">
                    <span
                      v-if="
                        bet.betType !== 'bookMaker' &&
                        bet.betType !== 'lineLadder'
                      "
                    >
                      {{
                        ((bet.averagePriceMatched - 1) * bet.stake)
                          | currencyFormat
                      }}
                    </span>
                    <span v-if="bet.betType === 'bookMaker'">
                      {{
                        ((bet.averagePriceMatched - 1) * bet.stake)
                          | currencyFormat(2)
                      }}
                    </span>
                    <span v-if="bet.betType === 'lineLadder'">
                      {{ ((bet.betRate - 1) * bet.stake) | currencyFormat(2) }}
                    </span>
                    <div
                      v-if="bet.status === 'VOID_VAR'"
                      style="font-size: 12px"
                      class="red--text"
                    >
                      Void by VAR
                    </div>
                    <div
                      v-if="bet.status === 'RT_INVALID_BET'"
                      class="red--text"
                    >
                      <v-tooltip top>
                        <template #activator="{ on, attrs }">
                          <v-btn
                            color="red"
                            block
                            tile
                            style="height: 100%; font-size: 12px"
                            text
                            v-bind="attrs"
                            class="pa-0"
                            v-on="on"
                          >
                            Invalid bet
                          </v-btn>
                        </template>
                        <span> {{ bet.reason }} </span>
                      </v-tooltip>
                    </div>
                  </td>
                  <!-- <td
                  v-if="bet.status === 'RT_INVALID_BET'"
                  class="overlay-invalid"
                  style="height: 100%"
                >
                  <v-tooltip top>
                    <template #activator="{ on, attrs }">
                      <v-btn
                        color="red"
                        block
                        tile
                        style="height: 100%"
                        text
                        v-bind="attrs"
                        v-on="on"
                      >
                        Invalid bet
                      </v-btn>
                    </template>
                    <span> {{ bet.reason }} </span>
                  </v-tooltip>
                </td> -->
                  <!-- <td v-if="bet.status === 'VOID_VAR'" class="overlay-invalid">
                  Void by VAR
                </td> -->
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ObCard',
  props: {
    betsGroup: { type: Object, default: () => {}, required: true },
    betsData: { type: Object, default: () => {}, required: true },
    sortBets: { type: Boolean, default: false }
  },
  data() {
    return {
      text: 'Odds'
    }
  },
  created() {
    this.getText()
  },
  methods: {
    getText() {
      this.betsGroup.markets.forEach((data) => {
        data.runners.forEach((i) => {
          i.bets.forEach((j) => {
            // this.text = j.betType
            const setValue = j.betType
            if (setValue === 'matchOdds' || setValue === 'fancy') {
              this.text = 'Odds'
            } else {
              this.text = 'Runs'
            }
          })
        })
      })
    },
      sortBetData(data, sortBets) {
        const key = sortBets ? 'matchedTime' : 'createdAt'
        return [...data].sort((a, b) => new Date(b[key]) - new Date(a[key]))
    }
  }
}
</script>
<style lang="scss" scoped>
// .overlay-invalid {
//   position: absolute;
//   background: rgba(0, 0, 0, 0.75);
//   left: 0em;
//   right: 0em;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   color: red;
// }
.opacity-0 {
  opacity: 0;
}
tr {
  position: relative;
}
</style>
